import {INETIALIZE_URL_BASE} from '../actions/urlBase'
export const urlBase = (state={urlBase:null} , action) =>{
    switch(action.type){
        case INETIALIZE_URL_BASE:
            return state={urlBase: action.url};
        default:
            return state;
    }
}